import { render, staticRenderFns } from "./Congrats.vue?vue&type=template&id=14064098&scoped=true"
import script from "./Congrats.vue?vue&type=script&lang=js"
export * from "./Congrats.vue?vue&type=script&lang=js"
import style0 from "./Congrats.vue?vue&type=style&index=0&id=14064098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14064098",
  null
  
)

export default component.exports